import { SiteService } from './../../../services/site/site.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { IOSFinalizada, ISite } from 'src/app/interfaces';
import { IAutorizacoes } from 'src/app/interfaces/token/IAutorizacoes';
import { IToken } from 'src/app/interfaces/token/IToken';
import { ListaPaginada } from 'src/app/models';
import { AuthenticationService, OSService } from 'src/app/services';

@Component({
  selector: 'app-listar-historico-chamados-finalizados',
  templateUrl: './listar-historico-chamados-finalizados.component.html',
  styleUrls: ['./listar-historico-chamados-finalizados.component.scss']
})
export class ListarHistoricoChamadosFinalizadosComponent
  implements OnInit, OnDestroy
{
  filtraForm!: FormGroup;
  subscriptions$ = new Subscription();
  pageSize = 5;
  chamados = new ListaPaginada<IOSFinalizada>();
  page = 1;
  permissoes: IToken;
  autorizacoes: IAutorizacoes;
  filterData: any;
  sitesOptions = new ListaPaginada<ISite>();
  token = this.authService.obterToken();
  // Permissoes

  gerenciarPermissoesTela() {
    this.autorizacoes = this.authService.obterToken()['autorizacoes'];
  }
  constructor(
    private fb: FormBuilder,
    private service: OSService,
    private authService: AuthenticationService,
    private siteService: SiteService
  ) {}

  //#region Controle filtro genérico
  exibirSite(site: ISite) {
    return `${site.codSite} | ${site.nome}`;
  }
  valorSite(site: ISite) {
    return site.codSite;
  }
  //#endregion

  ngOnInit() {
    this.getUserPermissoes();
    this.getSite();
    this.filtraForm = this.fb.group({
      FiltroPesquisar: [''],
      codigoOS: ['']
    });

    this.getHistoricoChamadosFinalizados();
    this.gerenciarPermissoesTela();
  }
  receiveFilterData(filterData: any) {
    this.filterData = filterData;
  }
  getSite() {
    this.subscriptions$.add(
      this.siteService
        .getSite({
          paginar: false,
          TipoUsuario: this.token.tipoUsuario,
          codContrato: this.token.codContrato,
          CodGrupoEconomico: this.token.codGrupoEconomico
        })
        .subscribe({
          next: ({ data }) => {
            this.sitesOptions = data;
          }
        })
    );
  }

  getHistoricoChamadosFinalizados(reiniciarPaginacao?: boolean) {
    if (reiniciarPaginacao) {
      this.chamados.paginaAtual = 1;
    }

    this.subscriptions$.add(
      this.service
        .getOSFinalizada({
          IdUsuario: this.token.id,
          CodSite: this.filterData?.site ?? '',
          NumSerie: this.filterData?.numserie ?? '',
          NumPat: this.filterData?.patrimonio ?? '',
          CodContrato: this.filterData?.contrato ?? this.permissoes.codContrato,
          FiltroPesquisar: this.filtraForm.get('FiltroPesquisar')?.value,
          CodGrupoEconomico: this.permissoes.codGrupoEconomico,
          paginaAtual: this.chamados.paginaAtual,
          itensPorPagina: this.chamados.itensPorPagina
        })
        .subscribe({
          next: ({ data }) => {
            this.chamados = data;
          }
        })
    );
  }

  getUserPermissoes() {
    this.permissoes = this.authService.obterToken();
    this.autorizacoes = this.permissoes.autorizacoes;
  }

  ngOnDestroy() {
    this.subscriptions$.unsubscribe();
  }
}
